import "core-js/modules/es.array.push.js";
import Feedback from '@/components/feedback/index.vue';
import Menu from "@/components/menu/index.vue";
import ChangePassword from "@/components/changePassword/index.vue";
import ServiceQRcode from "@/components/serviceQRcode/index.vue";
export default {
  components: {
    Feedback,
    Menu,
    ChangePassword,
    ServiceQRcode
  },
  data() {
    return {
      news: [],
      // 用户信息展开收起
      isSpread: false,
      boxshow: false
    };
  },
  mounted() {
    this.getNoticeList();
    this.getCartCount();
  },
  methods: {
    getNoticeList() {
      this.$axios.get('/shop/notice/topNoticeList/0').then(({
        data
      }) => {
        if (data.length == 2) {
          data = [...data, ...data];
        }
        this.news = data;
      });
    },
    goNewsDetDetail(id) {
      this.$router.push({
        path: '/newsDetDetail',
        query: {
          id: id
        }
      });
    },
    getCartCount() {
      if (this.$store.state.user.userType == 1) {
        this.$axios.post("/p/shopCart/enterpriseBasketList", {
          current: this.current,
          size: this.pageSize
        }, {}).then(({
          data
        }) => {
          this.$store.commit("updateCartCount", data.total);
        });
      }
    },
    toRoutePage(path) {
      if (this.$store.state.token && this.$store.state.user.userType == 1) {
        this.$router.push(path);
      } else {
        if (!this.$store.state.token) {
          this.$message({
            type: "warning",
            message: "当前未登录，请先登录。。。",
            duration: 1500
          });
          return;
        }
        if (!this.$store.state.user.userType || this.$store.state.user.userType == 0) {
          this.$message({
            type: "warning",
            message: "您还未进行认证，不允许操作当前系统，请先进行企业认证。。。",
            duration: 1500
          });
        }
      }
    },
    toOtherOperate(flag) {
      if (flag == 'feedback') {
        this.$refs.Feedback.show();
        return;
      }
      if (flag == 'chat') {
        // let routeUrl = this.$router.resolve({
        //   path: '/chat?shopId=1&chatType=1'
        // });
        // let chatUrl = window.open(routeUrl.href, 'view_window')
        // chatUrl.location.reload();

        this.$refs.ServiceQRcode.show();
        return;
      }
      if (flag == 'exit' || flag == 'changePasseord') {
        localStorage.setItem('publicSelectInfo', JSON.stringify({}));
        this.$store.commit("updateToken", "");
        this.$store.commit("updateUser", {});
        this.$store.commit("updateCartCount", 0);
        if (flag == 'exit') {
          this.$router.push("/home");
        } else if (flag == 'changePasseord') {
          this.$router.push("/login");
        }
        return;
      }
      if (flag == 'password') {
        this.$refs.ChangePassword.show();
      }
    },
    // 用户信息展开收起
    togglebox() {
      this.boxshow = !this.boxshow;
      this.isSpread = !this.isSpread;
    }
  }
};